import React from 'react';
import { Paper, Stack, Title, Group, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { SubscriberRegistration } from '../../../services/api';

interface PersonalDataFormProps {
  form: UseFormReturnType<SubscriberRegistration>;
}

export const PersonalDataForm: React.FC<PersonalDataFormProps> = ({ form }) => {
  return (
    <Paper p="xl" radius="md" withBorder>
      <Stack gap="md">
        <Title order={3} size="h4">
          Persönliche Daten
        </Title>
        <Group grow>
          <TextInput
            required
            label="Vorname"
            placeholder="Max"
            data-path="firstName"
            error={form.errors.firstName}
            withAsterisk
            {...form.getInputProps('firstName')}
          />
          <TextInput
            required
            label="Nachname"
            placeholder="Mustermann"
            data-path="lastName"
            error={form.errors.lastName}
            withAsterisk
            {...form.getInputProps('lastName')}
          />
        </Group>

        <TextInput
          required
          label="E-Mail"
          placeholder="ihre@email.de"
          data-path="email"
          error={form.errors.email}
          withAsterisk
          {...form.getInputProps('email')}
        />

        <TextInput
          label="Telefonnummer (optional)"
          placeholder="+49 123 456789"
          data-path="phoneNumber"
          error={form.errors.phoneNumber}
          {...form.getInputProps('phoneNumber')}
        />
      </Stack>
    </Paper>
  );
};
